import React, { useMemo } from 'react';

const SectionHeader = ({ styles, title, desc }) => (
  <div className={styles.sectionHeader}>
    <h2 className={styles.h2}>{title}</h2>
    <div className={styles.divider} />
    {desc ? <p className={styles.sectionDesc}>{desc}</p> : null}
  </div>
);

const InfoCard = ({ styles, title, items, tone = "feature" }) => (
  <div className={`${styles.rowCard} ${tone === "benefit" ? styles.rowCardBenefit : ""}`}>
    <div className={styles.rowCardHeader}>
      <div className={styles.rowCardTitle}>{title}</div>
    </div>

    <ul className={styles.cleanList}>
      {items.map((b, i) => (
        <li key={i} className={styles.cleanListItem}>
          <span className={styles.bulletDot} />
          <span className={styles.bulletText}>{b}</span>
        </li>
      ))}
    </ul>
  </div>
);

const RagResearch = ({ styles }) => {
  const data = useMemo(
    () => ({
      desc:
        "기업 내 대규모 문서·정책·지침·고객 데이터를 기반으로 정확하고 신뢰성 있는 답변을 제공하는 문서 기반 AI 지식 시스템을 연구합니다. LLM에 최신 정보와 전문성을 결합해 단순 답변을 넘어 근거 기반 추론을 제공합니다.",
      tech: [
        "문서 Chunking 전략(계층형, 의미 단위 기반, 하이브리드)",
        "벡터DB(Faiss, Milvus, Elastic) 기반 의미 검색",
        "Retrieval Fusion(BM25 + Dense Vector + Reranking)",
        "신뢰성 강화(출처 표시, hallucination 방지)",
        "Long-term Memory(대규모 대화 이력 반영)",
      ],
      value: [
        "내부 규정/정책 Q&A 자동화",
        "법률·의료·국방 등 오류에 민감한 분야 적용",
        "고객센터 자동화(응대비용 절감)",
        "기업 지식 자산의 구조화·효율화",
      ],
      examples: ["“규정집 기반 자동 질의응답 시스템”", "“AI 상담원 + 문서 검색 하이브리드 시스템”"],
    }),
    []
  );

  return (
    <section className={styles.section} id="research-rag">
      <div className={styles.container}>
        <SectionHeader styles={styles} title="RAG 시스템 (Retrieval-Augmented Generation)" desc={data.desc} />

        <div className={styles.panel}>
          <div className={styles.panelTopDots}>
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
          </div>

          <div className={styles.panelBodyGrid2}>
            <InfoCard styles={styles} title="주요 기술요소" items={data.tech} />
            <InfoCard styles={styles} title="비즈니스 가치" items={data.value} />
          </div>
        </div>

        <div className={styles.subSection}>
          <SectionHeader styles={styles} title="적용 예" desc={null} />
          <div className={styles.targetWrap}>
            {data.examples.map((t, i) => (
              <div className={styles.targetItem} key={i}>
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default RagResearch